import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { StarsInformation } from "../http/server-apis";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BiErrorCircle } from "react-icons/bi";
import { BsFillXCircleFill, BsGift, BsBell } from "react-icons/bs";


const Icons = {
  "error.svg": BiErrorCircle,
  "bell.svg": BsBell,
  "gift-svg.svg": BsGift,
};

const Splash = () => {
  const navigate = useNavigate();
  const [informationList, setInformationList] = useState([]);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  useEffect(() => {
    const alert = sessionStorage.getItem("alert");
    if (alert) navigate("/language", { replace: true });
  }, [informationList, navigate]);

  useQuery(
    ["get-all-information"],
    () =>
      StarsInformation("get", {
        postfix: `?LangCode=${"en"}`,
      }),
    {
      onSuccess(data) {
        if (data?.status === 200)
          if (data.data.Status === "success")
            setInformationList(
              data.data.Information instanceof Array
                ? data.data.Information
                : []
            );
          else setTimeout(() => navigate("/language", { replace: true }), 2000);
      },
    }
  );

  const Icon = useMemo(() => {
    if (informationList?.length) return Icons[informationList[0].Icon];
    return null;
  }, [informationList]);

  if (informationList?.length )
    return (
      <>
        <div className="h-[100vh] relative before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black before:opacity-60 bg-[url('../src/assets/images/splashscreen.png')] flex items-end bg-cover bg-center ">
          <div
            className={
              informationList[0]?.Image
                ? "bg-white  shadow-xl group shadow-black   flex-col flex items-center justify-center  p-2  w-full relative rounded-ss-xl rounded-se-xl"
                : "pt-5 pb-8 popup-gradient h-[55vh] rounded-ss-lg rounded-se-lg shadow-xl group shadow-black   flex-col flex items-center justify-center  p-2  w-full relative "
            }
          >
            {Icon && (
              <div className="w-[70px] h-[70px] absolute border-4 border-white rounded-full flex items-center justify-center text-5xl text-red-600 -top-8 bg-white z-30 drop-shadow-md">
                <Icon color={informationList[0]?.TextColor} />
              </div>
            )}
            <BsFillXCircleFill
              className=" absolute text-gray-400  text-4xl rounded-full  top-[1px] right-[1px] z-50"
              onClick={() => {
                sessionStorage.setItem("alert", true);
                navigate("/language", { replace: true });
              }}
            />

            <Slider
              arrows={false}
              navigate={false}
              className="w-full z-10"
              {...settings}
            >
              {informationList?.length &&
                informationList[0]?.InfoDetails?.map((i) => {
                  return (
                    <div key={`${i.InfoLangID} ${i.InfoID}`}>
                      {(i?.Image || informationList[0]?.Image) && (
                        <img
                          src={i?.Image || informationList[0]?.Image}
                          alt="Guide"
                          className="w-full rounded-xl"
                          onClick={() => {
                            sessionStorage.setItem("alert", true);
                            if (i?.Files || informationList[0]?.Files)
                              navigate("/web_links", {
                                state: {
                                  title: i?.Title || informationList[0]?.Title,
                                  link: i?.Files || informationList[0]?.Files,
                                },
                              });
                          }}
                        />
                      )}
                    {(i?.Title || informationList[0]?.Title) &&  <p
                        className="text-center pb-4  text-5xl text-red-600 flex items-center justify-center mt-14 font-bold"
                        onClick={() => {
                          sessionStorage.setItem("alert", true);
                          if (i?.Files ||  informationList[0]?.Files)
                            navigate("/web_links", {
                              state: {
                                title: i?.Title || informationList[0]?.Title,
                                link: i?.Files || informationList[0]?.Files,
                              },
                            });
                        }}
                      >
                        {i?.Title || informationList[0]?.Title}
                      </p>}
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
      </>
    );
  return (
    <div className="h-[100vh] relative bg-[url('../src/assets/images/splashscreen1.png')] flex items-end bg-no-repeat bg-white bg-center bg-contain " />
  );
};

export default Splash;



